import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';

var _a;
var PROMOTIONS_NAMESPACE = 'PROMOTIONS_NAMESPACE';
var SET_CATEGORIES = 'SET_CATEGORIES';
var SET_ENTRIES = 'SET_ENTRIES';
var SET_CATEGORIES_LANGUAGE = 'SET_CATEGORIES_LANGUAGE';
var SET_CATEGORIES_LOGGED_IN = 'SET_CATEGORIES_LOGGED_IN';
var SET_ENTRIES_LANGUAGE = 'SET_ENTRIES_LANGUAGE';
var SET_ENTRIES_LOGGED_IN = 'SET_ENTRIES_LOGGED_IN';
var promotionsGetters = {
    categories: function (state) {
        return state.categories;
    },
    entries: function (state) {
        return state.entries;
    },
};
var promotionsActions = {
    fetchCategories: function (_a, lang) {
        var commit = _a.commit, getters = _a.getters, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var userLoggedIn, categories;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        userLoggedIn = magic.session.isCreated();
                        if (getters.categories.length &&
                            state.categoriesLanguage === lang &&
                            state.categoriesLoggedIn === userLoggedIn) {
                            return [2 /*return*/];
                        }
                        commit(SET_CATEGORIES_LANGUAGE, lang);
                        commit(SET_CATEGORIES_LOGGED_IN, userLoggedIn);
                        return [4 /*yield*/, magic.methods.promotions.getCategories(lang)];
                    case 1:
                        categories = _b.sent();
                        commit(SET_CATEGORIES, categories);
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchEntries: function (_a, _b) {
        var commit = _a.commit, getters = _a.getters, state = _a.state;
        var type = _b.type, lang = _b.lang, mobile = _b.mobile;
        return __awaiter(this, void 0, void 0, function () {
            var userLoggedIn, entries;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        userLoggedIn = magic.session.isCreated();
                        if (getters.entries.length &&
                            state.entriesLanguage === lang &&
                            state.entriesLoggedIn === userLoggedIn) {
                            return [2 /*return*/];
                        }
                        commit(SET_ENTRIES_LANGUAGE, lang);
                        commit(SET_ENTRIES_LOGGED_IN, userLoggedIn);
                        return [4 /*yield*/, magic.methods.promotions.filter(type, lang, mobile)];
                    case 1:
                        entries = _c.sent();
                        commit(SET_ENTRIES, entries);
                        return [2 /*return*/];
                }
            });
        });
    },
    refreshEntries: function (_a, _b) {
        var commit = _a.commit;
        var type = _b.type, lang = _b.lang, mobile = _b.mobile;
        return __awaiter(this, void 0, void 0, function () {
            var entries;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, magic.methods.promotions.filter(type, lang, mobile)];
                    case 1:
                        entries = _c.sent();
                        commit(SET_ENTRIES, entries);
                        return [2 /*return*/];
                }
            });
        });
    },
};
var promotions = {
    namespaced: true,
    state: {
        categories: [],
        categoriesLanguage: null,
        categoriesLoggedIn: false,
        entries: [],
        entriesLanguage: null,
        entriesLoggedIn: false,
    },
    getters: promotionsGetters,
    actions: promotionsActions,
    mutations: (_a = {},
        _a[SET_CATEGORIES] = function (state, categories) {
            state.categories = categories;
        },
        _a[SET_ENTRIES] = function (state, entries) {
            state.entries = entries;
        },
        _a[SET_CATEGORIES_LANGUAGE] = function (state, language) {
            state.categoriesLanguage = language;
        },
        _a[SET_ENTRIES_LANGUAGE] = function (state, language) {
            state.entriesLanguage = language;
        },
        _a[SET_CATEGORIES_LOGGED_IN] = function (state, loggedIn) {
            state.categoriesLoggedIn = loggedIn;
        },
        _a[SET_ENTRIES_LOGGED_IN] = function (state, loggedIn) {
            state.entriesLoggedIn = loggedIn;
        },
        _a),
};

export { PROMOTIONS_NAMESPACE, promotions, promotionsActions, promotionsGetters };
